module.exports = __webpack_public_path__ + "static/041.thumb-5b234176b4ae4933c6f7b690b187e395.jpg";